<template>
  <div>
    <InvoicesSummary :invoices="invoices" :showDetail="showDetail" :detailed="true"></InvoicesSummary>
  </div>
</template>
<script>

import InvoicesSummary from '@/components/invoice/invoices-summary.vue'
export default {
  name : "invoiceDetailCustomerView",
  props: {
    invoices : {
      type : Array,
      default : () => []
    },
    filters : Object,
    showDetail : {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    };
  },
  components : {
    InvoicesSummary,
  },
  methods : {
  },
  computed : {
  }
}
</script>
<style lang="scss" scoped>


</style>
